import { ChevronDown, ChevronUp } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

/**
 * Not drag and drop: eleven rows at their longest, and a pointer gesture would still need this
 * keyboard path beside it. Reconsider if a list here ever grows past a screenful.
 */
export function VolgordeKnoppen({
  label,
  eerste,
  laatste,
  disabled,
  onOmhoog,
  onOmlaag,
}: {
  label: string;
  eerste: boolean;
  laatste: boolean;
  disabled?: boolean;
  onOmhoog: () => void;
  onOmlaag: () => void;
}) {
  const { t } = useTranslation();

  return (
    <span className="flex shrink-0 items-center">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-8"
        disabled={eerste || disabled}
        aria-label={t("volgorde.omhoog", { label })}
        onClick={onOmhoog}
      >
        <ChevronUp aria-hidden />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-8"
        disabled={laatste || disabled}
        aria-label={t("volgorde.omlaag", { label })}
        onClick={onOmlaag}
      >
        <ChevronDown aria-hidden />
      </Button>
    </span>
  );
}
